export default "__VITE_ASSET__BFHBwt0F__"